import notesReducer from './notes.slice';

export * from './notes.slice';
export * from './notes.thunk';

export default notesReducer;
